import React from "react"
import { Modal, Space, Typography, Rate, Input, Select } from "antd"
import { useTranslation } from "react-i18next"
import { ServiceReviewModalProps } from "./interface/ServiceReviewsInterfaces"

const { Text } = Typography
const { TextArea } = Input
const { Option } = Select

export const ServiceReviewModal: React.FC<ServiceReviewModalProps> = ({
	open,
	mode,
	formData,
	isLoading,
	users,
	isLoadingUsers,
	onSave,
	onCancel,
	onFormChange,
	onSearchUsers
}) => {
	const { t } = useTranslation("serviceReviews")

	return (
		<Modal
			title={mode === "create" ? t("modal.createTitle") : t("modal.editTitle")}
			open={open}
			onOk={onSave}
			onCancel={onCancel}
			confirmLoading={isLoading}
			okText={mode === "create" ? t("modal.createButton") : t("modal.saveButton")}
			cancelText={t("modal.cancelButton")}
			width={600}
		>
			<Space direction="vertical" size="large" style={{ width: "100%" }}>
				<div>
					<div style={{ marginBottom: "8px" }}>
						<Text strong>{t("modal.user")}</Text>
					</div>
					<Select
						style={{ width: "100%" }}
						placeholder={t("modal.userPlaceholder")}
						value={formData.userId}
						onChange={(value, option: any) => {
							// Buscar el usuario completo en las opciones
							const selectedUserOption = users.find(user => user.value === value)
							onFormChange({
								...formData,
								userId: value,
								userName: selectedUserOption?.label || "",
								userEmail: selectedUserOption?.email || ""
							})
						}}
						showSearch
						filterOption={false}
						onSearch={onSearchUsers}
						loading={isLoadingUsers}
						notFoundContent={isLoadingUsers ? "Buscando..." : "No se encontraron usuarios"}
					>
						{users.map(user => (
							<Option key={user.value} value={user.value}>
								{user.label} {user.email && `(${user.email})`}
							</Option>
						))}
					</Select>
				</div>

				<div>
					<div style={{ marginBottom: "8px" }}>
						<Text strong>{t("modal.rating")}</Text>
					</div>
					<Rate
						value={formData.rating}
						onChange={value => onFormChange({ ...formData, rating: value || 0 })}
					/>
				</div>

				<div>
					<Text strong>{t("modal.comment")}</Text>
					<TextArea
						rows={4}
						placeholder={t("modal.commentPlaceholder")}
						value={formData.review}
						onChange={e => onFormChange({ ...formData, review: e.target.value })}
					/>
				</div>
			</Space>
		</Modal>
	)
}

export default ServiceReviewModal
